import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTabIconInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18.0002,
			rx: 9,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 9.50018L9 13.5002",
			stroke: "#262626",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 5.5,
			r: 1.5,
			fill: "#262626"
		})
	]
});
export default SvgTabIconInfo;
